var __create = Object.create;
var __getProtoOf = Object.getPrototypeOf;
var __defProp = Object.defineProperty;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __toESM = (mod, isNodeMode, target) => {
  target = mod != null ? __create(__getProtoOf(mod)) : {};
  const to = isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target;
  for (let key of __getOwnPropNames(mod))
    if (!__hasOwnProp.call(to, key))
      __defProp(to, key, {
        get: () => mod[key],
        enumerable: true
      });
  return to;
};
var __commonJS = (cb, mod) => () => (mod || cb((mod = { exports: {} }).exports, mod), mod.exports);

// node_modules/loglevel/lib/loglevel.js
var require_loglevel = __commonJS((exports, module) => {
  (function(root, definition) {
    if (typeof define === "function" && define.amd) {
      define(definition);
    } else if (typeof module === "object" && module.exports) {
      module.exports = definition();
    } else {
      root.log = definition();
    }
  })(exports, function() {
    var noop = function() {};
    var undefinedType = "undefined";
    var isIE = typeof window !== undefinedType && typeof window.navigator !== undefinedType && /Trident\/|MSIE /.test(window.navigator.userAgent);
    var logMethods = [
      "trace",
      "debug",
      "info",
      "warn",
      "error"
    ];
    var _loggersByName = {};
    var defaultLogger = null;
    function bindMethod(obj, methodName) {
      var method = obj[methodName];
      if (typeof method.bind === "function") {
        return method.bind(obj);
      } else {
        try {
          return Function.prototype.bind.call(method, obj);
        } catch (e) {
          return function() {
            return Function.prototype.apply.apply(method, [obj, arguments]);
          };
        }
      }
    }
    function traceForIE() {
      if (console.log) {
        if (console.log.apply) {
          console.log.apply(console, arguments);
        } else {
          Function.prototype.apply.apply(console.log, [console, arguments]);
        }
      }
      if (console.trace)
        console.trace();
    }
    function realMethod(methodName) {
      if (methodName === "debug") {
        methodName = "log";
      }
      if (typeof console === undefinedType) {
        return false;
      } else if (methodName === "trace" && isIE) {
        return traceForIE;
      } else if (console[methodName] !== undefined) {
        return bindMethod(console, methodName);
      } else if (console.log !== undefined) {
        return bindMethod(console, "log");
      } else {
        return noop;
      }
    }
    function replaceLoggingMethods() {
      var level = this.getLevel();
      for (var i = 0;i < logMethods.length; i++) {
        var methodName = logMethods[i];
        this[methodName] = i < level ? noop : this.methodFactory(methodName, level, this.name);
      }
      this.log = this.debug;
      if (typeof console === undefinedType && level < this.levels.SILENT) {
        return "No console available for logging";
      }
    }
    function enableLoggingWhenConsoleArrives(methodName) {
      return function() {
        if (typeof console !== undefinedType) {
          replaceLoggingMethods.call(this);
          this[methodName].apply(this, arguments);
        }
      };
    }
    function defaultMethodFactory(methodName, _level, _loggerName) {
      return realMethod(methodName) || enableLoggingWhenConsoleArrives.apply(this, arguments);
    }
    function Logger(name, factory) {
      var self = this;
      var inheritedLevel;
      var defaultLevel;
      var userLevel;
      var storageKey = "loglevel";
      if (typeof name === "string") {
        storageKey += ":" + name;
      } else if (typeof name === "symbol") {
        storageKey = undefined;
      }
      function persistLevelIfPossible(levelNum) {
        var levelName = (logMethods[levelNum] || "silent").toUpperCase();
        if (typeof window === undefinedType || !storageKey)
          return;
        try {
          window.localStorage[storageKey] = levelName;
          return;
        } catch (ignore) {}
        try {
          window.document.cookie = encodeURIComponent(storageKey) + "=" + levelName + ";";
        } catch (ignore) {}
      }
      function getPersistedLevel() {
        var storedLevel;
        if (typeof window === undefinedType || !storageKey)
          return;
        try {
          storedLevel = window.localStorage[storageKey];
        } catch (ignore) {}
        if (typeof storedLevel === undefinedType) {
          try {
            var cookie = window.document.cookie;
            var cookieName = encodeURIComponent(storageKey);
            var location = cookie.indexOf(cookieName + "=");
            if (location !== -1) {
              storedLevel = /^([^;]+)/.exec(cookie.slice(location + cookieName.length + 1))[1];
            }
          } catch (ignore) {}
        }
        if (self.levels[storedLevel] === undefined) {
          storedLevel = undefined;
        }
        return storedLevel;
      }
      function clearPersistedLevel() {
        if (typeof window === undefinedType || !storageKey)
          return;
        try {
          window.localStorage.removeItem(storageKey);
        } catch (ignore) {}
        try {
          window.document.cookie = encodeURIComponent(storageKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
        } catch (ignore) {}
      }
      function normalizeLevel(input) {
        var level = input;
        if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
          level = self.levels[level.toUpperCase()];
        }
        if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
          return level;
        } else {
          throw new TypeError("log.setLevel() called with invalid level: " + input);
        }
      }
      self.name = name;
      self.levels = {
        TRACE: 0,
        DEBUG: 1,
        INFO: 2,
        WARN: 3,
        ERROR: 4,
        SILENT: 5
      };
      self.methodFactory = factory || defaultMethodFactory;
      self.getLevel = function() {
        if (userLevel != null) {
          return userLevel;
        } else if (defaultLevel != null) {
          return defaultLevel;
        } else {
          return inheritedLevel;
        }
      };
      self.setLevel = function(level, persist) {
        userLevel = normalizeLevel(level);
        if (persist !== false) {
          persistLevelIfPossible(userLevel);
        }
        return replaceLoggingMethods.call(self);
      };
      self.setDefaultLevel = function(level) {
        defaultLevel = normalizeLevel(level);
        if (!getPersistedLevel()) {
          self.setLevel(level, false);
        }
      };
      self.resetLevel = function() {
        userLevel = null;
        clearPersistedLevel();
        replaceLoggingMethods.call(self);
      };
      self.enableAll = function(persist) {
        self.setLevel(self.levels.TRACE, persist);
      };
      self.disableAll = function(persist) {
        self.setLevel(self.levels.SILENT, persist);
      };
      self.rebuild = function() {
        if (defaultLogger !== self) {
          inheritedLevel = normalizeLevel(defaultLogger.getLevel());
        }
        replaceLoggingMethods.call(self);
        if (defaultLogger === self) {
          for (var childName in _loggersByName) {
            _loggersByName[childName].rebuild();
          }
        }
      };
      inheritedLevel = normalizeLevel(defaultLogger ? defaultLogger.getLevel() : "WARN");
      var initialLevel = getPersistedLevel();
      if (initialLevel != null) {
        userLevel = normalizeLevel(initialLevel);
      }
      replaceLoggingMethods.call(self);
    }
    defaultLogger = new Logger;
    defaultLogger.getLogger = function getLogger(name) {
      if (typeof name !== "symbol" && typeof name !== "string" || name === "") {
        throw new TypeError("You must supply a name when creating a logger.");
      }
      var logger = _loggersByName[name];
      if (!logger) {
        logger = _loggersByName[name] = new Logger(name, defaultLogger.methodFactory);
      }
      return logger;
    };
    var _log = typeof window !== undefinedType ? window.log : undefined;
    defaultLogger.noConflict = function() {
      if (typeof window !== undefinedType && window.log === defaultLogger) {
        window.log = _log;
      }
      return defaultLogger;
    };
    defaultLogger.getLoggers = function getLoggers() {
      return _loggersByName;
    };
    defaultLogger["default"] = defaultLogger;
    return defaultLogger;
  });
});

// src/dateUtils.ts
var formatLastSynced = (date) => {
  if (!date)
    return "Never";
  const diffMs = Date.now() - date.getTime();
  const diffSec = Math.floor(diffMs / 1000);
  if (diffSec < 60)
    return "Just now";
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60)
    return `${diffMin} minute${diffMin === 1 ? "" : "s"} ago`;
  const diffHrs = Math.floor(diffMin / 60);
  if (diffHrs < 24)
    return `${diffHrs} hour${diffHrs === 1 ? "" : "s"} ago`;
  const diffDays = Math.floor(diffHrs / 24);
  return `${diffDays} day${diffDays === 1 ? "" : "s"} ago`;
};

// src/uuid.ts
var UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
var isUuid = (candidate) => {
  if (typeof candidate !== "string") {
    return false;
  }
  const trimmed = candidate.trim();
  return trimmed.length > 0 && UUID_PATTERN.test(trimmed);
};

// src/nsn.ts
var stripWhitespace = (value) => value.replace(/\s+/g, "");
var normalizeNsn = (value) => {
  if (typeof value !== "string") {
    return null;
  }
  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }
  return stripWhitespace(trimmed).toUpperCase();
};
var getBaseNsn = (value) => {
  const normalized = normalizeNsn(value);
  if (!normalized) {
    return null;
  }
  const segments = normalized.split("-").filter((segment) => segment.length > 0);
  if (segments.length < 4) {
    return normalized;
  }
  return segments.slice(0, 3).join("-");
};

// src/logger.ts
var import_loglevel = __toESM(require_loglevel(), 1);
function detectProduction() {
  if (typeof process !== "undefined" && process.env) {
    return false;
  }
  return false;
}
var isProd = detectProduction();
var isBrowser = typeof window !== "undefined";
var defaultService = "equip";
function setLogService(service) {
  defaultService = service;
}
function setLogLevel(level) {
  import_loglevel.default.setLevel(level);
}
import_loglevel.default.setLevel(isProd ? "warn" : "debug");
function serializeError(error) {
  if (error instanceof Error) {
    return {
      name: error.name,
      message: error.message,
      stack: error.stack
    };
  }
  return { message: String(error) };
}
function formatLogEntry(level, message, context) {
  const { timestamp: _t, level: _l, service: ctxService, message: _m, ...safeContext } = context ?? {};
  return {
    ...safeContext,
    timestamp: new Date().toISOString(),
    level,
    service: ctxService ?? defaultService,
    message
  };
}
function output(level, message, context) {
  const entry = formatLogEntry(level, message, context);
  if (isProd || !isBrowser) {
    const consoleMethod = level === "trace" || level === "debug" ? "log" : level;
    console[consoleMethod](JSON.stringify(entry));
  } else {
    const prefix = `[${level.toUpperCase()}]${context?.component ? ` [${context.component}]` : ""}`;
    const consoleMethod = level === "trace" || level === "debug" ? "log" : level;
    if (context && Object.keys(context).length > 0) {
      const { component: _component, ...rest } = context;
      if (Object.keys(rest).length > 0) {
        console[consoleMethod](prefix, message, rest);
      } else {
        console[consoleMethod](prefix, message);
      }
    } else {
      console[consoleMethod](prefix, message);
    }
  }
}
var logger = {
  trace: (message, context) => {
    if (import_loglevel.default.getLevel() <= import_loglevel.default.levels.TRACE) {
      output("trace", message, context);
    }
  },
  debug: (message, context) => {
    if (import_loglevel.default.getLevel() <= import_loglevel.default.levels.DEBUG) {
      output("debug", message, context);
    }
  },
  info: (message, context) => {
    if (import_loglevel.default.getLevel() <= import_loglevel.default.levels.INFO) {
      output("info", message, context);
    }
  },
  warn: (message, context) => {
    if (import_loglevel.default.getLevel() <= import_loglevel.default.levels.WARN) {
      output("warn", message, context);
    }
  },
  error: (message, context) => {
    if (import_loglevel.default.getLevel() <= import_loglevel.default.levels.ERROR) {
      output("error", message, context);
    }
  },
  child: (defaultContext) => ({
    trace: (message, context) => logger.trace(message, { ...defaultContext, ...context }),
    debug: (message, context) => logger.debug(message, { ...defaultContext, ...context }),
    info: (message, context) => logger.info(message, { ...defaultContext, ...context }),
    warn: (message, context) => logger.warn(message, { ...defaultContext, ...context }),
    error: (message, context) => logger.error(message, { ...defaultContext, ...context })
  })
};

// src/assetStatus.ts
var ASSET_STATUS_KEYS = {
  AVAILABLE: "available",
  ASSIGNED: "assigned",
  BINNED: "binned",
  MAINTENANCE: "maintenance",
  TRANSFERRED: "transferred",
  SHIPPED: "shipped",
  DISPOSED: "disposed"
};
var ASSET_STATUS_VALUES = [
  ASSET_STATUS_KEYS.AVAILABLE,
  ASSET_STATUS_KEYS.ASSIGNED,
  ASSET_STATUS_KEYS.BINNED,
  ASSET_STATUS_KEYS.MAINTENANCE,
  ASSET_STATUS_KEYS.TRANSFERRED,
  ASSET_STATUS_KEYS.SHIPPED,
  ASSET_STATUS_KEYS.DISPOSED
];
var ASSET_STATUS_TRANSITIONS = {
  [ASSET_STATUS_KEYS.AVAILABLE]: [
    ASSET_STATUS_KEYS.ASSIGNED,
    ASSET_STATUS_KEYS.BINNED,
    ASSET_STATUS_KEYS.MAINTENANCE,
    ASSET_STATUS_KEYS.TRANSFERRED,
    ASSET_STATUS_KEYS.SHIPPED,
    ASSET_STATUS_KEYS.DISPOSED
  ],
  [ASSET_STATUS_KEYS.ASSIGNED]: [
    ASSET_STATUS_KEYS.AVAILABLE,
    ASSET_STATUS_KEYS.BINNED,
    ASSET_STATUS_KEYS.DISPOSED
  ],
  [ASSET_STATUS_KEYS.BINNED]: [
    ASSET_STATUS_KEYS.AVAILABLE,
    ASSET_STATUS_KEYS.MAINTENANCE,
    ASSET_STATUS_KEYS.DISPOSED
  ],
  [ASSET_STATUS_KEYS.MAINTENANCE]: [
    ASSET_STATUS_KEYS.AVAILABLE,
    ASSET_STATUS_KEYS.BINNED,
    ASSET_STATUS_KEYS.DISPOSED
  ],
  [ASSET_STATUS_KEYS.TRANSFERRED]: [
    ASSET_STATUS_KEYS.AVAILABLE,
    ASSET_STATUS_KEYS.ASSIGNED
  ],
  [ASSET_STATUS_KEYS.SHIPPED]: [
    ASSET_STATUS_KEYS.AVAILABLE,
    ASSET_STATUS_KEYS.ASSIGNED
  ],
  [ASSET_STATUS_KEYS.DISPOSED]: [
    ASSET_STATUS_KEYS.AVAILABLE,
    ASSET_STATUS_KEYS.ASSIGNED
  ]
};
function isValidAssetTransition(currentStatus, targetStatus) {
  const allowed = ASSET_STATUS_TRANSITIONS[currentStatus];
  return allowed?.includes(targetStatus) ?? false;
}
function isAssetStatusKey(value) {
  return typeof value === "string" && ASSET_STATUS_VALUES.includes(value);
}
function applyAssetStatusKey(entityData, statusKey) {
  const next = { ...entityData ?? {} };
  next.asset_status_key = statusKey;
  if (statusKey === ASSET_STATUS_KEYS.ASSIGNED || statusKey === ASSET_STATUS_KEYS.DISPOSED) {
    next.location_id = null;
  }
  return next;
}

// src/roles.ts
var EQUIP_APP_ROLES = ["user", "admin", "viewer", "frontwindow", "service-member", "comptroller", "finance", "hr", "cif"];
var ROLE_DISPLAY_LABELS = {
  viewer: "visitor"
};
var filterEquipRoles = (roles) => roles.reduce((acc, r) => {
  const lower = r.toLowerCase();
  if (EQUIP_APP_ROLES.includes(lower))
    acc.push(lower);
  return acc;
}, []);
var getRoleDisplayLabel = (role) => {
  const key = role.toLowerCase();
  return ROLE_DISPLAY_LABELS[key] ?? role;
};
// src/workflowFailure.ts
class ApplicationFailure extends Error {
  type;
  nonRetryable;
  details;
  constructor(message, type, nonRetryable, details, cause) {
    super(message, cause ? { cause } : undefined);
    this.name = "ApplicationFailure";
    this.type = type ?? null;
    this.nonRetryable = nonRetryable ?? false;
    this.details = details ?? [];
  }
  static create(options) {
    return new ApplicationFailure(options.message, options.type, options.nonRetryable, options.details, options.cause);
  }
  static nonRetryable(message, type, ...details) {
    return new ApplicationFailure(message, type ?? null, true, details);
  }
  static retryable(message, type, ...details) {
    return new ApplicationFailure(message, type ?? null, false, details);
  }
}
// src/nomenclature.ts
function formatNomenclatureWithSize(nomenclature, size) {
  const name = nomenclature ?? "";
  const normalizedSize = size?.trim() ?? "";
  if (!normalizedSize)
    return name;
  if (name.includes(`(${normalizedSize})`))
    return name;
  return `${name} (${normalizedSize})`;
}
// src/loaValidation.ts
var MAX_LOA_LENGTH = 200;
var LOA_PATTERN = /^[A-Za-z0-9 \-./_]+$/;
var validateLoa = (loa) => {
  if (loa === undefined || loa === null) {
    return;
  }
  if (typeof loa !== "string") {
    return "LOA must be a string";
  }
  const trimmed = loa.trim();
  if (trimmed.length === 0) {
    return;
  }
  if (trimmed.length > MAX_LOA_LENGTH) {
    return `LOA too long: ${trimmed.length} characters. Maximum is ${MAX_LOA_LENGTH}`;
  }
  if (!LOA_PATTERN.test(trimmed)) {
    return "LOA contains invalid characters. Allowed: letters, numbers, spaces, hyphens, periods, slashes, underscores";
  }
  return;
};
export {
  validateLoa,
  setLogService,
  setLogLevel,
  serializeError,
  normalizeNsn,
  logger,
  isValidAssetTransition,
  isUuid,
  isAssetStatusKey,
  getRoleDisplayLabel,
  getBaseNsn,
  formatNomenclatureWithSize,
  formatLastSynced,
  filterEquipRoles,
  applyAssetStatusKey,
  ROLE_DISPLAY_LABELS,
  MAX_LOA_LENGTH,
  LOA_PATTERN,
  EQUIP_APP_ROLES,
  ApplicationFailure,
  ASSET_STATUS_VALUES,
  ASSET_STATUS_TRANSITIONS,
  ASSET_STATUS_KEYS
};
